<svg
  width="62"
  height="54"
  viewBox="0 0 62 54"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.0904 52.1311L0 36.7148L5.20116 24.8998L8.49884 23.5162L3.66055 16.3135L3.76241 6.51401L10.0267 0.972995L21.1166 0L27.9921 5.91379L30.4621 19.4978L35.4659 15.7069L47.5426 17.1917L55.7486 22.0251L56.6335 26.3151L43.0735 44.8525L30.7232 48.0495L25.0063 53.6221L10.0904 52.1311Z"
    fill="white"
  />
  <path
    d="M11.1629 24.4067C11.3666 24.4572 15.2691 27.3193 15.2691 27.3193L22.4246 26.7697L23.0167 24.255L29.1091 22.0311L31.1781 22.6692L34.8578 20.3252L36.2647 17.7031L44.2606 18.575L45.05 20.0977L48.6023 19.9524L52.9632 22.8145L53.6507 24.3877L51.0533 26.8771L48.8952 27.4647L40.8483 42.7483L37.2451 43.4559L36.131 44.4921L28.4598 44.5869L22.5711 47.4237L20.483 49.4455L13.773 48.4536L11.4366 46.8487L4.49113 39.3175L3.00781 36.1142L4.66938 35.5835L6.52194 30.0362L5.52882 28.0523L6.91028 27.3193L9.53951 27.6416L9.87692 25.6956L11.1629 24.4067Z"
    fill="black"
  />
  <path
    d="M19.7593 29.3417C19.2372 29.0068 6.98872 21.0712 5.57543 15.3723C4.86879 12.5165 5.32078 9.55326 6.85503 7.03863C8.38928 4.52401 10.8212 2.74861 13.6987 2.04098C14.5708 1.82616 15.4685 1.71875 16.3597 1.71875C21.4781 1.71875 25.9026 5.16846 27.1313 10.1029C28.5446 15.8019 21.4145 28.4761 21.1089 29.0068L20.6123 29.8851L19.7593 29.3417Z"
    fill="black"
  />
  <path
    d="M16.3585 2.66498C20.9167 2.66498 25.061 5.7356 26.2006 10.3289C27.5438 15.7309 20.2737 28.5441 20.2737 28.5441C20.2737 28.5441 7.84053 20.5453 6.49727 15.1433C5.15401 9.7413 8.48352 4.28874 13.9202 2.96193C14.7415 2.75975 15.5563 2.66498 16.3585 2.66498ZM16.3585 0.769531C15.3908 0.769531 14.4168 0.889576 13.4682 1.11703C10.3424 1.88153 7.70047 3.80856 6.0389 6.54432C4.37733 9.28008 3.88077 12.496 4.65107 15.5982C6.12802 21.5562 17.9055 29.2707 19.2423 30.1363L20.9485 31.2356L21.948 29.4792C22.731 28.1018 29.5428 15.8383 28.0659 9.8803C26.7226 4.51619 21.9161 0.769531 16.3585 0.769531Z"
    fill="white"
  />
  <path
    d="M16.2245 16.532C18.6224 16.532 20.5663 14.6028 20.5663 12.223C20.5663 9.84326 18.6224 7.91406 16.2245 7.91406C13.8267 7.91406 11.8828 9.84326 11.8828 12.223C11.8828 14.6028 13.8267 16.532 16.2245 16.532Z"
    fill="white"
  />
</svg>
